import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_get_customer_pop, fn_set_customer_pop } from "../../../../function/FnBodyDetail";
import { fn_bridge_order_accept } from "../../../../function/FnPosBridge";
import { hungryPandaMobileOrderFg } from "utils/Utils";

/** 3행×4열 그리드 순서: 1·5·10·15 / 20·30·45·60 / 70·80·90·120 */
const CST_EXPECT_TIME_OPTIONS = [
  { key: "min1", min: "1", label: "즉시" },
  { key: "min5", min: "5", label: "5분" },
  { key: "min10", min: "10", label: "10분" },
  { key: "min15", min: "15", label: "15분" },
  { key: "min20", min: "20", label: "20분" },
  { key: "min30", min: "30", label: "30분" },
  { key: "min45", min: "45", label: "45분" },
  { key: "min60", min: "60", label: "60분" },
  { key: "min70", min: "70", label: "70분" },
  { key: "min80", min: "80", label: "80분" },
  { key: "min90", min: "90", label: "90분" },
  { key: "min120", min: "120", label: "120분" },
];

@observer
class CustomerExpectTimeView extends Component {
    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerCstExpectTimeView ? ' layer_open' : '')}>
                <div className="bg" />
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>
                                {hungryPandaMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg)
                                    ? "조리시간 선택"
                                    : "고객 예상수령시간 선택"}
                            </h1>
                        </div>
                        <div className="list_radio_time list_radio_time_grid_3x4">
                            <div className="list_radio_time_grid_cells">
                                {CST_EXPECT_TIME_OPTIONS.map(opt => (
                                    <label key={opt.key}><input
                                        type="radio"
                                        name="time"
                                        checked={fn_get_customer_pop(rootStore, opt.key) === "Y"}
                                        onChange={() => {
                                            rootStore.layerStore.setChangeCstTime(opt.min);
                                            rootStore.viewStore.initCustomerPopBtn();
                                            fn_set_customer_pop(rootStore, opt.key);
                                        }}
                                    /><span>{opt.label}</span></label>
                                ))}
                            </div>
                            <div className="wrap_full_btn">
                                <span className="f_l"><button className="btn_cancel"
                                    onClick={event => {
                                        rootStore.layerStore.setLayerAlertType("");
                                        layerStore.setLayerCstExpectTime(false)
                                    }}
                                >취소</button></span>
                                <span className="f_r"><button className="btn_submit"
                                    onClick={event => {
                                        rootStore.layerStore.setLayerAlertType("");
                                        fn_bridge_order_accept(rootStore, rootStore.viewStore.getOrderDetail.mobileOrderNo, rootStore.layerStore.getChangeCstTime, rootStore.viewStore.getOrderDetail.orderNo)
                                        //fn_change_step(rootStore, '200');
                                    }}
                                >확인</button></span>
                            </div>

                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => {layerStore.setLayerCstExpectTime(false);rootStore.viewStore.initCustomerPopBtn();}}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerExpectTimeView;
